module.exports = (__webpack_require__(1))(40);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/actions/openModal.js from dll-reference rlink_core
// module id = 569
// module chunks = 0